import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Grid, Typography, Paper } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import logo from '../assets/images/cards/Chinmaya-Mission-Logo.gif';

export default function DonationHistory() {

    const { accessToken, signOut } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const [donationHistory, setDonationHistory] = useState();
    
    //console.log("Donations History form :", accessToken);

    
    useEffect(() => {
        if (accessToken) {
          DonationHistoryFetch();
        }
      }, [accessToken]);
    
      const DonationHistoryFetch = async () => {
      let response, data;
      try {    
        const response = await fetch(`${API_URL}/gquery`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-cmdfw-jwt-token': `${accessToken}`,
          },
            body: JSON.stringify({
                query: `
                        query {
                          donationHistory {
                            donations {
                                transactionId
                                eventTypesEntity {
                                    eventTypeId
                                    name
                                    eventYear
                                }
                                donationAmount
                                paymentStatus
                                createdAt 
                                createdBy 
                            }
                          }
                        }
                      `,
          }),
        });
  
        const data = await response.json();
        if (response.ok) {
          console.log("Event history data API call:", response, data.data.donationHistory.events);

          setDonationHistory(data.data.donationHistory.donations);
        } else {
          if (response.status === 403) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'OTP expired');
            //handleLogout(); // Logout user
          } else {
            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.message || 'Membership fetch failed');
            }
          }
        }
      } catch (error) {
        console.error("Error fetching Event Txns History :", error);
        //signOut();
        //navigate('/');
      }
    };    
    
    
  return (
    
    <Grid container alignItems="left" >
 
        <Paper elevation={3}>
            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
            <Typography variant="h7" align="left" gutterBottom>
                <b>Donation History</b>
            </Typography>
            </Paper>
            <div><br /></div>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ backgroundColor: '#1976d2', color: 'white' }}>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Event Name</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }} >Event Year</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Total Amount</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Transaction Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {donationHistory && donationHistory.map((row) => (
            <TableRow
              key={row.transactionId}
            >
              <TableCell align="right">{row.eventTypesEntity.name}</TableCell>
              <TableCell align="right">{row.eventTypesEntity.eventYear}</TableCell>
              <TableCell align="right">{row.donationAmount}</TableCell>
              <TableCell align="right">{row.createdAt}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Paper>
    </Grid>
  );
}
